import { useCallback, useEffect, useState } from 'react';
import { useElementErrorMsg, useFetch } from '@/app/hooks';
import { materialsListLabels } from '../apis';
import type { MaterialsListLabelsData, MaterialV1Label } from '../types';

export const useSearchLabels = ({ currentType }: { currentType: 'edit' | 'create' | undefined }) => {
  const { showErrorMsg } = useElementErrorMsg();
  const { data: labels, run: getLabels } = useFetch(
    (params?: MaterialsListLabelsData) => {
      return materialsListLabels(params);
    },
    {
      manual: true,
      onSuccess: (data) => {
        if (data.error) {
          showErrorMsg(data.error);
        }
      },
    },
  );

  const [realLabels, setRealLables] = useState<MaterialV1Label[]>();

  useEffect(() => {
    setRealLables([...(labels?.data?.labels || [])]);
  }, [labels]);

  useEffect(() => {
    getLabels();
  }, [currentType, getLabels]);

  // 添加新标签到列表
  const handleAddLabel = useCallback((label: MaterialV1Label) => {
    setRealLables((prev) => {
      // 检查是否已存在
      if (prev?.some((l) => l.id === label.id)) {
        return prev;
      }
      return [...(prev || []), label];
    });
  }, []);

  return {
    labels: realLabels,
    getLabels,
    handleAddLabel,
  };
};
